var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reject"},[_c('h1',[_vm._v("You are just one step away")]),_c('div',[_vm._v("The charge was declined and you have the option to uninstall if you choose to...")]),_c('div',[_c('a',{attrs:{"href":_vm.$route.query.return_url}},[_vm._v("RETRY")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }